export const baseEvent = {
  context: 'REAL_ESTATE_PROPERTY',
} as const
